module.exports = __webpack_public_path__ + "media/sfx_flap.4355dd66.wav";